export default "__VITE_ASSET__fFn$izVO__"